import { render, staticRenderFns } from "./BadgeboxAlreadyTaken.vue?vue&type=template&id=6f82455a&"
import script from "./BadgeboxAlreadyTaken.vue?vue&type=script&lang=js&"
export * from "./BadgeboxAlreadyTaken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports